import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import { ContactCompanyType } from 'models/contact_companies'
import { featureFlagService } from 'utils/featureFlagService'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { NewConvenienceLocationPage } from '../new-company-pages/NewConvenienceLocationPage'

export default function ConvenienceDoorPage() {
  const { enableNewCompanyPage, isLoading } = featureFlagService()
  const urlParams = useParams()
  const convenienceID = parseInt(urlParams.convenience_id!)

  if (enableNewCompanyPage) {
    return (
      <NewConvenienceLocationPage
        convenienceID={convenienceID}
        isLoading={isLoading}
      />
    )
  }

  return (
    <_ConvenienceDoorPage convenienceID={convenienceID} isLoading={isLoading} />
  )
}

function _ConvenienceDoorPage({
  convenienceID,
  isLoading: isExternalLoading,
}: {
  convenienceID: number
  isLoading: boolean
}) {
  const { preferences } = usePreferences()
  const api = apiService()
  const {
    data,
    isLoading: isConvenienceLoading,
    isError,
    error,
  } = api.useGetConvenienceDoor(convenienceID)

  const isLoading = isExternalLoading || isConvenienceLoading

  return (
    <CommonPage
      uniqueCompanyTypeId={convenienceID}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data?.chain_proxy,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="convenience-doors"
      companyTypeSlug="convenience"
      breadcrumbs={[
        {
          title: 'Chain',
          breadcrumb: data?.cstore?.name,
          url: `/convenience/chain/${preferences?.company_type_prefix_map[ContactCompanyType.Convenience]}${data?.cstore?.chain_id}`,
        },
      ]}
      getFieldsFromData={(data) => {
        return {
          contactCompanyId: data?.chain_proxy.id,
          companyName: data?.cstore?.name,
          websiteAddress: data?.cstore?.website,
          phone: data?.cstore?.phone,
          doorProxyId: data?.id,
          address: {
            addressInfo: {
              fullAddress: data?.cstore?.address,
              city: data?.cstore?.city,
              state: data?.cstore?.state,
            },
            fullAddressInfo: data?.cstore?.address_info,
            addressUrl: data?.cstore?.place_url,
          },
        }
      }}
    />
  )
}
